var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMoneyTransfer24X24 = function SvgMoneyTransfer24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#money-transfer-24x24_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.783 1.6C6.148 1.6 1.6 5.732 1.6 12A.8.8 0 010 12C0 4.828 5.286 0 11.783 0c4.34 0 8.063 1.927 10.063 5.156l.578-2.31a.8.8 0 011.552.388L22.86 7.697a.809.809 0 01-.369.51.8.8 0 01-.605.09l-4.48-1.12a.8.8 0 01.388-1.553l2.896.724C19.07 3.436 15.806 1.6 11.783 1.6zm1.323 9.572c-.748-.265-1.576-.585-2.04-.95-.146-.115-.21-.377-.157-.653.026-.138.147-.598.617-.74.771-.233 1.3.076 1.492.22.366.273.884.198 1.158-.168a.83.83 0 00-.167-1.16 3.297 3.297 0 00-1.233-.555V6.83a.828.828 0 10-1.654 0v.392l-.024.006-.05.014c-.906.274-1.582 1.048-1.765 2.02-.169.896.123 1.764.762 2.266.526.413 1.253.763 2.51 1.208.837.297.819.975.772 1.253-.095.564-.568 1.173-1.383 1.179-.8.005-1.05-.035-1.664-.437a.826.826 0 00-1.145.24.83.83 0 00.24 1.147c.662.434 1.151.61 1.747.675v.379a.828.828 0 101.655 0v-.459a2.963 2.963 0 001.226-.682c.503-.463.842-1.09.956-1.767.23-1.375-.514-2.617-1.853-3.091zM24 12a.8.8 0 10-1.6 0c0 6.268-4.548 10.4-10.182 10.4-4.023 0-7.286-1.835-8.908-4.748l2.896.724a.8.8 0 00.388-1.552l-4.48-1.12a.8.8 0 00-.97.582l-1.12 4.48a.8.8 0 001.552.388l.578-2.31c2 3.23 5.724 5.156 10.064 5.156C18.715 24 24 19.172 24 12z",
    fill: "#33AA40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "money-transfer-24x24_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgMoneyTransfer24X24;